import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {"context":{"apiName":"lending-sprout-subgraph"}} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: any;
  BigInt: any;
  Bytes: any;
  Int8: any;
};

export type BlockChangedFilter = {
  number_gte: Scalars['Int'];
};

export type Block_Height = {
  hash?: InputMaybe<Scalars['Bytes']>;
  number?: InputMaybe<Scalars['Int']>;
  number_gte?: InputMaybe<Scalars['Int']>;
};

export type ContractState = {
  __typename?: 'ContractState';
  id: Scalars['Bytes'];
  totalLended: Scalars['BigInt'];
};

export type ContractState_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  and?: InputMaybe<Array<InputMaybe<ContractState_Filter>>>;
  id?: InputMaybe<Scalars['Bytes']>;
  id_contains?: InputMaybe<Scalars['Bytes']>;
  id_gt?: InputMaybe<Scalars['Bytes']>;
  id_gte?: InputMaybe<Scalars['Bytes']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_lt?: InputMaybe<Scalars['Bytes']>;
  id_lte?: InputMaybe<Scalars['Bytes']>;
  id_not?: InputMaybe<Scalars['Bytes']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  or?: InputMaybe<Array<InputMaybe<ContractState_Filter>>>;
  totalLended?: InputMaybe<Scalars['BigInt']>;
  totalLended_gt?: InputMaybe<Scalars['BigInt']>;
  totalLended_gte?: InputMaybe<Scalars['BigInt']>;
  totalLended_in?: InputMaybe<Array<Scalars['BigInt']>>;
  totalLended_lt?: InputMaybe<Scalars['BigInt']>;
  totalLended_lte?: InputMaybe<Scalars['BigInt']>;
  totalLended_not?: InputMaybe<Scalars['BigInt']>;
  totalLended_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
};

export enum ContractState_OrderBy {
  Id = 'id',
  TotalLended = 'totalLended'
}

export type Lended = {
  __typename?: 'Lended';
  amount: Scalars['BigInt'];
  blockNumber: Scalars['BigInt'];
  blockTimestamp: Scalars['BigInt'];
  id: Scalars['Bytes'];
  lender: Scalars['Bytes'];
  recordId: Scalars['BigInt'];
  reward: Scalars['BigInt'];
  transactionHash: Scalars['Bytes'];
};

export type Lended_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  and?: InputMaybe<Array<InputMaybe<Lended_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['Bytes']>;
  id_contains?: InputMaybe<Scalars['Bytes']>;
  id_gt?: InputMaybe<Scalars['Bytes']>;
  id_gte?: InputMaybe<Scalars['Bytes']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_lt?: InputMaybe<Scalars['Bytes']>;
  id_lte?: InputMaybe<Scalars['Bytes']>;
  id_not?: InputMaybe<Scalars['Bytes']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  lender?: InputMaybe<Scalars['Bytes']>;
  lender_contains?: InputMaybe<Scalars['Bytes']>;
  lender_gt?: InputMaybe<Scalars['Bytes']>;
  lender_gte?: InputMaybe<Scalars['Bytes']>;
  lender_in?: InputMaybe<Array<Scalars['Bytes']>>;
  lender_lt?: InputMaybe<Scalars['Bytes']>;
  lender_lte?: InputMaybe<Scalars['Bytes']>;
  lender_not?: InputMaybe<Scalars['Bytes']>;
  lender_not_contains?: InputMaybe<Scalars['Bytes']>;
  lender_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  or?: InputMaybe<Array<InputMaybe<Lended_Filter>>>;
  recordId?: InputMaybe<Scalars['BigInt']>;
  recordId_gt?: InputMaybe<Scalars['BigInt']>;
  recordId_gte?: InputMaybe<Scalars['BigInt']>;
  recordId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  recordId_lt?: InputMaybe<Scalars['BigInt']>;
  recordId_lte?: InputMaybe<Scalars['BigInt']>;
  recordId_not?: InputMaybe<Scalars['BigInt']>;
  recordId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  reward?: InputMaybe<Scalars['BigInt']>;
  reward_gt?: InputMaybe<Scalars['BigInt']>;
  reward_gte?: InputMaybe<Scalars['BigInt']>;
  reward_in?: InputMaybe<Array<Scalars['BigInt']>>;
  reward_lt?: InputMaybe<Scalars['BigInt']>;
  reward_lte?: InputMaybe<Scalars['BigInt']>;
  reward_not?: InputMaybe<Scalars['BigInt']>;
  reward_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
};

export enum Lended_OrderBy {
  Amount = 'amount',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  Lender = 'lender',
  RecordId = 'recordId',
  Reward = 'reward',
  TransactionHash = 'transactionHash'
}

export type LendingRecord = {
  __typename?: 'LendingRecord';
  amount: Scalars['BigInt'];
  id: Scalars['Bytes'];
  lended: Lended;
  lender: Scalars['Bytes'];
  recordId: Scalars['BigInt'];
  reward: Scalars['BigInt'];
  withdrawn?: Maybe<Withdrawn>;
};

export type LendingRecord_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  and?: InputMaybe<Array<InputMaybe<LendingRecord_Filter>>>;
  id?: InputMaybe<Scalars['Bytes']>;
  id_contains?: InputMaybe<Scalars['Bytes']>;
  id_gt?: InputMaybe<Scalars['Bytes']>;
  id_gte?: InputMaybe<Scalars['Bytes']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_lt?: InputMaybe<Scalars['Bytes']>;
  id_lte?: InputMaybe<Scalars['Bytes']>;
  id_not?: InputMaybe<Scalars['Bytes']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  lended?: InputMaybe<Scalars['String']>;
  lended_?: InputMaybe<Lended_Filter>;
  lended_contains?: InputMaybe<Scalars['String']>;
  lended_contains_nocase?: InputMaybe<Scalars['String']>;
  lended_ends_with?: InputMaybe<Scalars['String']>;
  lended_ends_with_nocase?: InputMaybe<Scalars['String']>;
  lended_gt?: InputMaybe<Scalars['String']>;
  lended_gte?: InputMaybe<Scalars['String']>;
  lended_in?: InputMaybe<Array<Scalars['String']>>;
  lended_lt?: InputMaybe<Scalars['String']>;
  lended_lte?: InputMaybe<Scalars['String']>;
  lended_not?: InputMaybe<Scalars['String']>;
  lended_not_contains?: InputMaybe<Scalars['String']>;
  lended_not_contains_nocase?: InputMaybe<Scalars['String']>;
  lended_not_ends_with?: InputMaybe<Scalars['String']>;
  lended_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  lended_not_in?: InputMaybe<Array<Scalars['String']>>;
  lended_not_starts_with?: InputMaybe<Scalars['String']>;
  lended_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  lended_starts_with?: InputMaybe<Scalars['String']>;
  lended_starts_with_nocase?: InputMaybe<Scalars['String']>;
  lender?: InputMaybe<Scalars['Bytes']>;
  lender_contains?: InputMaybe<Scalars['Bytes']>;
  lender_gt?: InputMaybe<Scalars['Bytes']>;
  lender_gte?: InputMaybe<Scalars['Bytes']>;
  lender_in?: InputMaybe<Array<Scalars['Bytes']>>;
  lender_lt?: InputMaybe<Scalars['Bytes']>;
  lender_lte?: InputMaybe<Scalars['Bytes']>;
  lender_not?: InputMaybe<Scalars['Bytes']>;
  lender_not_contains?: InputMaybe<Scalars['Bytes']>;
  lender_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  or?: InputMaybe<Array<InputMaybe<LendingRecord_Filter>>>;
  recordId?: InputMaybe<Scalars['BigInt']>;
  recordId_gt?: InputMaybe<Scalars['BigInt']>;
  recordId_gte?: InputMaybe<Scalars['BigInt']>;
  recordId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  recordId_lt?: InputMaybe<Scalars['BigInt']>;
  recordId_lte?: InputMaybe<Scalars['BigInt']>;
  recordId_not?: InputMaybe<Scalars['BigInt']>;
  recordId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  reward?: InputMaybe<Scalars['BigInt']>;
  reward_gt?: InputMaybe<Scalars['BigInt']>;
  reward_gte?: InputMaybe<Scalars['BigInt']>;
  reward_in?: InputMaybe<Array<Scalars['BigInt']>>;
  reward_lt?: InputMaybe<Scalars['BigInt']>;
  reward_lte?: InputMaybe<Scalars['BigInt']>;
  reward_not?: InputMaybe<Scalars['BigInt']>;
  reward_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  withdrawn?: InputMaybe<Scalars['String']>;
  withdrawn_?: InputMaybe<Withdrawn_Filter>;
  withdrawn_contains?: InputMaybe<Scalars['String']>;
  withdrawn_contains_nocase?: InputMaybe<Scalars['String']>;
  withdrawn_ends_with?: InputMaybe<Scalars['String']>;
  withdrawn_ends_with_nocase?: InputMaybe<Scalars['String']>;
  withdrawn_gt?: InputMaybe<Scalars['String']>;
  withdrawn_gte?: InputMaybe<Scalars['String']>;
  withdrawn_in?: InputMaybe<Array<Scalars['String']>>;
  withdrawn_lt?: InputMaybe<Scalars['String']>;
  withdrawn_lte?: InputMaybe<Scalars['String']>;
  withdrawn_not?: InputMaybe<Scalars['String']>;
  withdrawn_not_contains?: InputMaybe<Scalars['String']>;
  withdrawn_not_contains_nocase?: InputMaybe<Scalars['String']>;
  withdrawn_not_ends_with?: InputMaybe<Scalars['String']>;
  withdrawn_not_ends_with_nocase?: InputMaybe<Scalars['String']>;
  withdrawn_not_in?: InputMaybe<Array<Scalars['String']>>;
  withdrawn_not_starts_with?: InputMaybe<Scalars['String']>;
  withdrawn_not_starts_with_nocase?: InputMaybe<Scalars['String']>;
  withdrawn_starts_with?: InputMaybe<Scalars['String']>;
  withdrawn_starts_with_nocase?: InputMaybe<Scalars['String']>;
};

export enum LendingRecord_OrderBy {
  Amount = 'amount',
  Id = 'id',
  Lended = 'lended',
  LendedAmount = 'lended__amount',
  LendedBlockNumber = 'lended__blockNumber',
  LendedBlockTimestamp = 'lended__blockTimestamp',
  LendedId = 'lended__id',
  LendedLender = 'lended__lender',
  LendedRecordId = 'lended__recordId',
  LendedReward = 'lended__reward',
  LendedTransactionHash = 'lended__transactionHash',
  Lender = 'lender',
  RecordId = 'recordId',
  Reward = 'reward',
  Withdrawn = 'withdrawn',
  WithdrawnAmount = 'withdrawn__amount',
  WithdrawnBlockNumber = 'withdrawn__blockNumber',
  WithdrawnBlockTimestamp = 'withdrawn__blockTimestamp',
  WithdrawnId = 'withdrawn__id',
  WithdrawnLender = 'withdrawn__lender',
  WithdrawnRecordId = 'withdrawn__recordId',
  WithdrawnTransactionHash = 'withdrawn__transactionHash'
}

/** Defines the order direction, either ascending or descending */
export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type Query = {
  __typename?: 'Query';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  contractState?: Maybe<ContractState>;
  contractStates: Array<ContractState>;
  lended?: Maybe<Lended>;
  lendeds: Array<Lended>;
  lendingRecord?: Maybe<LendingRecord>;
  lendingRecords: Array<LendingRecord>;
  withdrawn?: Maybe<Withdrawn>;
  withdrawns: Array<Withdrawn>;
};


export type Query_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type QueryContractStateArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryContractStatesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ContractState_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ContractState_Filter>;
};


export type QueryLendedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLendedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Lended_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Lended_Filter>;
};


export type QueryLendingRecordArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryLendingRecordsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LendingRecord_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LendingRecord_Filter>;
};


export type QueryWithdrawnArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type QueryWithdrawnsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Withdrawn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Withdrawn_Filter>;
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Access to subgraph metadata */
  _meta?: Maybe<_Meta_>;
  contractState?: Maybe<ContractState>;
  contractStates: Array<ContractState>;
  lended?: Maybe<Lended>;
  lendeds: Array<Lended>;
  lendingRecord?: Maybe<LendingRecord>;
  lendingRecords: Array<LendingRecord>;
  withdrawn?: Maybe<Withdrawn>;
  withdrawns: Array<Withdrawn>;
};


export type Subscription_MetaArgs = {
  block?: InputMaybe<Block_Height>;
};


export type SubscriptionContractStateArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionContractStatesArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<ContractState_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<ContractState_Filter>;
};


export type SubscriptionLendedArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLendedsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Lended_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Lended_Filter>;
};


export type SubscriptionLendingRecordArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionLendingRecordsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<LendingRecord_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<LendingRecord_Filter>;
};


export type SubscriptionWithdrawnArgs = {
  block?: InputMaybe<Block_Height>;
  id: Scalars['ID'];
  subgraphError?: _SubgraphErrorPolicy_;
};


export type SubscriptionWithdrawnsArgs = {
  block?: InputMaybe<Block_Height>;
  first?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Withdrawn_OrderBy>;
  orderDirection?: InputMaybe<OrderDirection>;
  skip?: InputMaybe<Scalars['Int']>;
  subgraphError?: _SubgraphErrorPolicy_;
  where?: InputMaybe<Withdrawn_Filter>;
};

export type Withdrawn = {
  __typename?: 'Withdrawn';
  amount: Scalars['BigInt'];
  blockNumber: Scalars['BigInt'];
  blockTimestamp: Scalars['BigInt'];
  id: Scalars['Bytes'];
  lender: Scalars['Bytes'];
  recordId: Scalars['BigInt'];
  transactionHash: Scalars['Bytes'];
};

export type Withdrawn_Filter = {
  /** Filter for the block changed event. */
  _change_block?: InputMaybe<BlockChangedFilter>;
  amount?: InputMaybe<Scalars['BigInt']>;
  amount_gt?: InputMaybe<Scalars['BigInt']>;
  amount_gte?: InputMaybe<Scalars['BigInt']>;
  amount_in?: InputMaybe<Array<Scalars['BigInt']>>;
  amount_lt?: InputMaybe<Scalars['BigInt']>;
  amount_lte?: InputMaybe<Scalars['BigInt']>;
  amount_not?: InputMaybe<Scalars['BigInt']>;
  amount_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  and?: InputMaybe<Array<InputMaybe<Withdrawn_Filter>>>;
  blockNumber?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_gte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockNumber_lt?: InputMaybe<Scalars['BigInt']>;
  blockNumber_lte?: InputMaybe<Scalars['BigInt']>;
  blockNumber_not?: InputMaybe<Scalars['BigInt']>;
  blockNumber_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_gte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_in?: InputMaybe<Array<Scalars['BigInt']>>;
  blockTimestamp_lt?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_lte?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_not?: InputMaybe<Scalars['BigInt']>;
  blockTimestamp_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  id?: InputMaybe<Scalars['Bytes']>;
  id_contains?: InputMaybe<Scalars['Bytes']>;
  id_gt?: InputMaybe<Scalars['Bytes']>;
  id_gte?: InputMaybe<Scalars['Bytes']>;
  id_in?: InputMaybe<Array<Scalars['Bytes']>>;
  id_lt?: InputMaybe<Scalars['Bytes']>;
  id_lte?: InputMaybe<Scalars['Bytes']>;
  id_not?: InputMaybe<Scalars['Bytes']>;
  id_not_contains?: InputMaybe<Scalars['Bytes']>;
  id_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  lender?: InputMaybe<Scalars['Bytes']>;
  lender_contains?: InputMaybe<Scalars['Bytes']>;
  lender_gt?: InputMaybe<Scalars['Bytes']>;
  lender_gte?: InputMaybe<Scalars['Bytes']>;
  lender_in?: InputMaybe<Array<Scalars['Bytes']>>;
  lender_lt?: InputMaybe<Scalars['Bytes']>;
  lender_lte?: InputMaybe<Scalars['Bytes']>;
  lender_not?: InputMaybe<Scalars['Bytes']>;
  lender_not_contains?: InputMaybe<Scalars['Bytes']>;
  lender_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
  or?: InputMaybe<Array<InputMaybe<Withdrawn_Filter>>>;
  recordId?: InputMaybe<Scalars['BigInt']>;
  recordId_gt?: InputMaybe<Scalars['BigInt']>;
  recordId_gte?: InputMaybe<Scalars['BigInt']>;
  recordId_in?: InputMaybe<Array<Scalars['BigInt']>>;
  recordId_lt?: InputMaybe<Scalars['BigInt']>;
  recordId_lte?: InputMaybe<Scalars['BigInt']>;
  recordId_not?: InputMaybe<Scalars['BigInt']>;
  recordId_not_in?: InputMaybe<Array<Scalars['BigInt']>>;
  transactionHash?: InputMaybe<Scalars['Bytes']>;
  transactionHash_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_gte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_in?: InputMaybe<Array<Scalars['Bytes']>>;
  transactionHash_lt?: InputMaybe<Scalars['Bytes']>;
  transactionHash_lte?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_contains?: InputMaybe<Scalars['Bytes']>;
  transactionHash_not_in?: InputMaybe<Array<Scalars['Bytes']>>;
};

export enum Withdrawn_OrderBy {
  Amount = 'amount',
  BlockNumber = 'blockNumber',
  BlockTimestamp = 'blockTimestamp',
  Id = 'id',
  Lender = 'lender',
  RecordId = 'recordId',
  TransactionHash = 'transactionHash'
}

export type _Block_ = {
  __typename?: '_Block_';
  /** The hash of the block */
  hash?: Maybe<Scalars['Bytes']>;
  /** The block number */
  number: Scalars['Int'];
  /** Integer representation of the timestamp stored in blocks for the chain */
  timestamp?: Maybe<Scalars['Int']>;
};

/** The type for the top-level _meta field */
export type _Meta_ = {
  __typename?: '_Meta_';
  /**
   * Information about a specific subgraph block. The hash of the block
   * will be null if the _meta field has a block constraint that asks for
   * a block number. It will be filled if the _meta field has no block constraint
   * and therefore asks for the latest  block
   *
   */
  block: _Block_;
  /** The deployment ID */
  deployment: Scalars['String'];
  /** If `true`, the subgraph encountered indexing errors at some past block */
  hasIndexingErrors: Scalars['Boolean'];
};

export enum _SubgraphErrorPolicy_ {
  /** Data will be returned even if the subgraph has indexing errors */
  Allow = 'allow',
  /** If the subgraph has indexing errors, data will be omitted. The default. */
  Deny = 'deny'
}

export type SproutLendingRecordsQueryVariables = Exact<{
  lender?: InputMaybe<Scalars['Bytes']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type SproutLendingRecordsQuery = { __typename?: 'Query', sprout: Array<{ __typename?: 'LendingRecord', id: any, recordId: any, lender: any, amount: any, reward: any, lended: { __typename?: 'Lended', blockTimestamp: any, blockNumber: any, transactionHash: any }, withdrawn?: { __typename?: 'Withdrawn', id: any, transactionHash: any, lender: any } | null }> };

export type SproutContractStateQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SproutContractStateQuery = { __typename?: 'Query', sprout?: { __typename?: 'ContractState', totalLended: any } | null };


export const SproutLendingRecordsDocument = gql`
    query sproutLendingRecords($lender: Bytes, $first: Int) {
  sprout: lendingRecords(where: {lender: $lender}, first: $first) {
    id
    recordId
    lender
    amount
    reward
    lended {
      blockTimestamp
      blockNumber
      transactionHash
    }
    withdrawn {
      id
      transactionHash
      lender
    }
  }
}
    `;

/**
 * __useSproutLendingRecordsQuery__
 *
 * To run a query within a React component, call `useSproutLendingRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSproutLendingRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSproutLendingRecordsQuery({
 *   variables: {
 *      lender: // value for 'lender'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSproutLendingRecordsQuery(baseOptions?: Apollo.QueryHookOptions<SproutLendingRecordsQuery, SproutLendingRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SproutLendingRecordsQuery, SproutLendingRecordsQueryVariables>(SproutLendingRecordsDocument, options);
      }
export function useSproutLendingRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SproutLendingRecordsQuery, SproutLendingRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SproutLendingRecordsQuery, SproutLendingRecordsQueryVariables>(SproutLendingRecordsDocument, options);
        }
export type SproutLendingRecordsQueryHookResult = ReturnType<typeof useSproutLendingRecordsQuery>;
export type SproutLendingRecordsLazyQueryHookResult = ReturnType<typeof useSproutLendingRecordsLazyQuery>;
export type SproutLendingRecordsQueryResult = Apollo.QueryResult<SproutLendingRecordsQuery, SproutLendingRecordsQueryVariables>;
export const SproutContractStateDocument = gql`
    query sproutContractState($id: ID!) {
  sprout: contractState(id: $id) {
    totalLended
  }
}
    `;

/**
 * __useSproutContractStateQuery__
 *
 * To run a query within a React component, call `useSproutContractStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useSproutContractStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSproutContractStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSproutContractStateQuery(baseOptions: Apollo.QueryHookOptions<SproutContractStateQuery, SproutContractStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SproutContractStateQuery, SproutContractStateQueryVariables>(SproutContractStateDocument, options);
      }
export function useSproutContractStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SproutContractStateQuery, SproutContractStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SproutContractStateQuery, SproutContractStateQueryVariables>(SproutContractStateDocument, options);
        }
export type SproutContractStateQueryHookResult = ReturnType<typeof useSproutContractStateQuery>;
export type SproutContractStateLazyQueryHookResult = ReturnType<typeof useSproutContractStateLazyQuery>;
export type SproutContractStateQueryResult = Apollo.QueryResult<SproutContractStateQuery, SproutContractStateQueryVariables>;